import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IRequestResult, IResult } from "../../../../../common/interfaces";
import { environment as env } from "../../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import { IUpdateSubRoute } from "../interfaces/update-sub-route.interface";
import { ICreateSubRouteFrequency } from "../sub-routes-frequency/interfaces/create-sub-route-frequency.interface";
import SubRouteCollaboratorAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-collaborator/sub-route-collaborator.entity";
import orderDeliveryWindowsAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-delivery-windows/order-delivery-windows.entity";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "sub_route_delivery_windows";

@Injectable({
  providedIn: "root",
})
export class SubRouteDeliveryTimesService extends AbstractService<
  orderDeliveryWindowsAttributes,
  ICreateSubRouteFrequency,
  IUpdateSubRoute
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findBySubRouteId(
    subRouteId: string
  ): Observable<IResult<orderDeliveryWindowsAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${subRouteId}`;
    return this.http.get<IResult<orderDeliveryWindowsAttributes>>(API_URL);
  }

  set(subRouteId: string, data:orderDeliveryWindowsAttributes): Observable<IResult<orderDeliveryWindowsAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${subRouteId}`
    return this.http.post<IResult<orderDeliveryWindowsAttributes>>(API_URL, data);
  }

  delete(subRouteId: string, deliveryTimeId: string){
    const API_UIRL: string = `${apiUrl}api/${moduleName}/${subRouteId}/${deliveryTimeId}`
    return this.http.delete<IRequestResult<orderDeliveryWindowsAttributes>>(API_UIRL);
  }

  updateDT(subRouteId: string, deliveryTimeId: string, data:orderDeliveryWindowsAttributes){
    const API_UIRL: string = `${apiUrl}api/${moduleName}/${subRouteId}/${deliveryTimeId}`
    return this.http.patch<IRequestResult<orderDeliveryWindowsAttributes>>(API_UIRL,data);
  }
  
}
